// extracted by mini-css-extract-plugin
module.exports = {"textBold":"CommandService__textBold--3I3HWfPIJAUKdo13nHiJ-0"};